<p>deals-distrib works!</p>
<div class="tile is-parent">
    <article class="tile is-child box">
       
       <p class="subtitle">Satış dağılımı</p>
       <!-- <div 
       class="content" 
       *ngIf="(groupedTypes$ | async) as groups"> -->
          <!-- <p>{{groupedTypes$ | async | json}}</p> -->
          <!-- <p *ngFor="group of groups">
             

          </p> -->
          <!-- <p>{{groups|json}} </p> -->
          <!-- <p *ngFor="let group of groups"> {{group.type}}: {{group.sum}} </p> -->
       <!-- </div> -->
    </article>
 </div>